import React from 'react';
import styled from 'styled-components';
import Selector from 'shared/design-system/components/Selector';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import { IconDefinition, IconProp } from '@fortawesome/fontawesome-svg-core';

export interface PeriodTypeProps {
  questionId: number;
  haveExtraDetails: boolean;
  pageOptionProps: {
    variant: string;
    options: string[];
    onClick: (value: string) => void;
    getSelected: (val: string) => boolean;
    getLabel: (val: string) => JSX.Element;
  };
  getOptionDetails: (
    option: string,
    index: number,
  ) => {
    heading?: string;
    subHeading?: string[];
    icon: IconDefinition | IconProp;
  };
}

const getMaxWidth = (length: number) => {
  const result = 228 * length + 24 * (length - 1);
  return result > 732 ? 732 : result;
};

const StyledDiv = styled.div<{ length: number; haveExtraDetails: boolean }>`
  display: ${({ haveExtraDetails }) =>
    haveExtraDetails ? 'grid' : 'flex; & > div { flex: 1; }'};
  grid-template-columns: repeat(
    ${({ length }) => (length > 3 ? 3 : length)},
    1fr
  );
  width: ${({ length }) => getMaxWidth(length)}px;
  grid-auto-flow: dense;

  & div:nth-child(odd) {
    grid-row: 1;
  }

  & div:nth-child(even) {
    grid-row: 2;
  }
  gap: ${SPACERS.medium};
`;

const StyledExtraDetails = styled.div`
  padding: ${SPACERS.small};
  border-radius: ${SPACERS.extraTiny};
  background-color: ${COLORS.grayLightest};
  .extra-details-heading {
    margin-bottom: ${SPACERS.tiny};
  }
  ul {
    padding: 0;
    vertical-align: top;
    display: inline-block;
    margin: 0 0 0 ${SPACERS.medium};
  }
`;

const PeriodType: React.FC<PeriodTypeProps> = ({
  pageOptionProps,
  haveExtraDetails,
  getOptionDetails,
}) => {
  const { options, getLabel, getSelected, onClick } = pageOptionProps;
  return (
    <StyledDiv length={options.length} haveExtraDetails={haveExtraDetails}>
      {options.map((o, i) => {
        const details = getOptionDetails(o, i);
        return (
          <>
            <Selector
              key={i}
              variant="primary-radio"
              label={getLabel(o)}
              selected={getSelected(o)}
              icon={details.icon}
              onClick={() => onClick(o)}
              className="selector-option"
            />
            {details.heading && details.subHeading && (
              <StyledExtraDetails>
                <TrueImpactText
                  variant="body-bold"
                  className="extra-details-heading"
                >
                  {details.heading}
                </TrueImpactText>
                <ul>
                  {details.subHeading.map((o, i) => (
                    <li key={i}>{o}</li>
                  ))}
                </ul>
              </StyledExtraDetails>
            )}
          </>
        );
      })}
    </StyledDiv>
  );
};

export default PeriodType;
